import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import axios from "axios";
import { Loading } from "../Common/Loading";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../../config";

const Products = () => {
  const { id } = useParams();
  const [data, setData] = useState({
    category: "",
    products: "",
    loading: true,
    error: null,
  });
  const { category, products, loading, error } = data;

  useEffect(() => {
    getProducts();
  }, [id]);

  const getProducts = async () => {
    await axios
      .get(`${BASE_URL}/products/${id}`)
      .then((response) => {
        setData({
          ...data,
          category: response.data.category,
          products: response.data.products,
          loading: false,
        });
      })
      .catch((error) => {
        setData({
          ...data,
          error: error,
        });
      });
  };
  if (loading === true) {
    return (
      <>
        <Loading />
      </>
    );
  }

  return (
    <>
      {category ? (
        <>
          <div
            className="tf-page-title"
            style={{
              backgroundImage: `url(${category.image})`,
            }}
          >
            <div className="container-full">
              <div className="row">
                <div className="col-12">
                  <div className="heading text-center">{category.title}</div>
                </div>
              </div>
            </div>
          </div>
          {products ? (
            <>
              <section className="flat-spacing-1">
                <div className="container-full">
                  <div className="tf-shop-control grid-1 align-items-center">
                    <div className="tf-control-sorting d-flex justify-content-end">
                      <div
                        className="tf-dropdown-sort"
                        data-bs-toggle="dropdown"
                      >
                        <div className="btn-select">
                          <span className="text-sort-value">Default</span>
                          <span className="icon icon-arrow-down"></span>
                        </div>
                        <div className="dropdown-menu">
                          <div className="select-item active">
                            <span className="text-value-item">Default</span>
                          </div>
                          <div className="select-item ">
                            <span className="text-value-item">A-Z</span>
                          </div>
                          <div className="select-item ">
                            <span className="text-value-item">Z-A</span>
                          </div>
                          <div className="select-item ">
                            <span className="text-value-item">
                              Price: Low to High
                            </span>
                          </div>
                          <div className="select-item ">
                            <span className="text-value-item">
                              Price: High to Low
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="grid-layout wrapper-shop" data-grid="grid-4">
                    {products.map((prod, index) => (
                      <ProductCard key={index} {...prod} />
                    ))}
                  </div>
                </div>
              </section>
            </>
          ) : (
            <div className="text-center p-5">
              <h6>No Products Found</h6>
            </div>
          )}
        </>
      ) : (
        <div className="text-center p-5">
          <h6>No Category Found</h6>
        </div>
      )}
    </>
  );
};

export default Products;
